
export const getVerifiedStatus = () => {
    const isVerified = localStorage.getItem('isVerified');
    return isVerified !== null ? isVerified : null;
}